import { collection, query, getDocs, limit, orderBy } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export async function fetchFinancialLedger(limitCount = 1000) {
  const finRef = collection(db, 'artifacts', appId, 'public', 'data', 'financial_ledger');
  const finQ = query(finRef, orderBy('date', 'desc'), limit(limitCount));
  const finSnap = await getDocs(finQ);
  return finSnap.docs.map((d) => d.data());
}

export async function fetchTimesheetEntries(limitCount = 1000) {
  const timeRef = collection(db, 'artifacts', appId, 'public', 'data', 'timesheet_entries');
  const timeQ = query(timeRef, orderBy('createdAt', 'desc'), limit(limitCount));
  const timeSnap = await getDocs(timeQ);
  return timeSnap.docs.map((d) => d.data());
}
